import { initArgus } from "@solvari/common-fe/argus/service";
void initArgus();
